import React from "react";
import CordwoodHistoryListItem from "../../components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const CordwoodHistoryListPage = ()  => {

    useTitle(t`List Cordwood History`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <CordwoodHistoryListItem showAdd={true} {...query} />
        </Box>
    )
}

export default CordwoodHistoryListPage;
